import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-search" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "search-container",
      onEnter: _ctx.onEnter
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "search-container",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearchContainerClick($event)))
        }, [
          _hoisted_2,
          _createVNode(_component_InputText, {
            modelValue: _ctx.searchInput,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchInput) = $event)),
            id: "search-input",
            type: "text",
            name: "search",
            placeholder: _ctx.t('search.placeholder'),
            onKeydown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onInputKeydown($event)))
          }, null, 8, ["modelValue", "placeholder"])
        ], 512), [
          [_vShow, _ctx.searchActive]
        ])
      ]),
      _: 1
    }, 8, ["onEnter"])
  ]))
}